<template>
  <div class="english-container">
    <h2>1. Korte Handleiding – Draadloze Tracker</h2>
    <p  style="text-align: left;" >Om te voorkomen dat het apparaat onbedoeld wordt uitgeschakeld en daardoor niet meer te vinden is, hebben we de opstart- en afsluitmethoden verbeterd.
</p>
  

<h4> 1.1.Aan/uitzetten</h4>
  <p style="text-align: left;">1.1.1 Aan: 3 sec knop indrukken, hoor beltoon.</p>

   <img src="../assets/gid_1_nl_1.png" alt="Wireless Tag Logo" class="image_1" />

  
  <p style="text-align: left;">
     1.1.2 Uit: 2x drukken, dan 3 sec ingedrukt houden, 2 pieptonen.  </p>
  <p style="text-align: left;">
    <strong>Opmerking: het instellen van een uitschake.ltimer is bedoeld om onbedoelde uitschakelingen te voorkomen en ervoor te zorgen dat het apparaat effectief kan blijven zoeken.</strong>
  </p>

  

<h4>1.2.Controleren op updates</h4>
  
      <p style="text-align: left;">
        Om de Apple® Zoek mijn®-app te gebruiken om items te vinden, wordt de nieuwste versie van iOS®, iPadOS® of macOS® aanbevolen. De Zoek mijn-app op Apple Watch vereist de nieuwste versie van watchOS®.    
  </p>
 

<h3>2. Voeg uw tracker toe</h3>
<h4>2.1 De app starten</h4>
<p style="text-align: left;">
  Open Zoek mijn > Items > Voeg ander object toe > Verbinden > naam kiezen > Voltooien.
</p>
<p style="text-align: left;">
2.1.1 Open de Zoek mijn-app op uw ondersteunde iPhone® of iPad®
</p>
<p style="text-align: left;">
2.1.2 Sta meldingen van de app toe.
</p>

<h4>2.2 Sluit uw tracker aan</h4>
  <p style="text-align: left;">
2.2.1 Schakel uw tracker in, selecteer het tabblad 'Items' en tik vervolgens op het tabblad 'Item toevoegen' en tik op <strong>'Voeg ander object toe'</strong>.</p>
<p style="text-align: left;">
2.2.2 Zorg ervoor dat je Item tracker dicht bij je telefoon is. Wacht... tot je de pop-up "Draadloze tag" ziet en tik dan op "verbinden".</p>

<p style="text-align: left;">
2.2.3 Kies een herkenbare naam en emoji voor je item tracker en tik op "Doorgaan"
</p>

<p style="text-align: left;">
2.2.4 Zoek Mijn vraagt om bevestiging om uw tracker voor uw Apple ID toe te voegen - tik op "Doorgaan".
</p>

<p style="text-align: left;">
2.2.5 Tik op “Voltooien” en uw tracker is ingesteld en klaar om verbinding te maken met het item dat u wilt lokaliseren, bijvoorbeeld uw sleutels.
</p>

<h3>3. Gebruik</h3>

<h4>3.1 Uw artikel vinden</h4>
 <p style="text-align: left;">
Wanneer uw object in de buurt is, tikt u op "Geluid afspelen" om uw Locator te laten piepen. U kunt het dan vinden. Is het buiten bereik, dan kunt u de laatst bekende locatie van de Locator vinden.
  </p>

  <h4>3.2 Meldingen</h4>

   <p style="text-align: left;">
U ontvangt een melding wanneer u uw tracker achterlaat en deze zich niet meer binnen het bereik van uw apparaat bevindt.
  </p>
  <p style="text-align: left;"> Let op: “Melden wanneer gevonden” kan alleen worden geactiveerd als uw tracker buiten bereik is.

  </p>


  <h4>3.3 Items delen</h4>
   <p style="text-align: left;">
De mensen met wie je het hebt gedeeld, kunnen het vinden en ontvangen geen meldingen over ongeïdentificeerde tracking.  </p>

<p style="text-align: left;">
Om Items delen te kunnen gebruiken, moeten jij en je vrienden de openbare bètaversies van iOS 17, iPadOS 17 of macOS 14 Sonoma of nieuwer hebben geïnstalleerd.
</p>

  <h4>3.4 Verloren modus</h4>
   <p style="text-align: left;">
Wanneer je voorwerp verloren is, activeer je de verloren modus. Je ontvangt een melding wanneer de locatie beschikbaar is. Je kunt een telefoonnummer of e-mailadres achterlaten zodat de vinder van je voorwerp contact met je kan opnemen.
  </p>

     <p style="text-align: left;">
Let op: Wanneer de 'Verloren-modus' is ingeschakeld, is je Item Locator vergrendeld en kan niemand anders ermee koppelen. VERWIJDER GEEN ITEM uit de app. Je Item Locator is vergrendeld en kan door niemand anders worden gebruikt.
</p>
  
 <h4>3.5 Item verwijderen</h4>
  <p style="text-align: left;">
Zorg ervoor dat het item in de buurt is. Je kunt het item in de app verwijderen. Er zou een beltoon moeten klinken om aan te geven dat het item succesvol is verwijderd. Vervolgens kunnen andere mensen het gebruiken.  </p>

   <p style="text-align: left;">
Let op: Wanneer de 'Verloren modus' is ingeschakeld, mag u GEEN ITEM uit de APP verwijderen. Anders wordt uw Item tracker vergrendeld en kan niemand anders ermee koppelen.
  </p>

  <h4>3.6 Uw tracker terugzetten naar de fabrieksinstellingen</h4>

   <p style="text-align: left;">
Wanneer uw item zich buiten het bereik van uw telefoon bevindt en uw tracker is verwijderd uit de Zoek mijn-app, kunnen andere mensen het apparaat niet meer gebruiken. U moet uw Locator resetten, zodat andere mensen het weer kunnen gebruiken.
</p>
   <p style="text-align: left;">
Fabrieksinstellingen herstellen: Druk twee keer op de aan/uit knop, u hoort één pieptoon. Druk vervolgens vier keer snel achter elkaar op de functieknop en houd deze een vijfde keer ingedrukt totdat u een pieptoon hoort. Het apparaat is nu gereset. Het apparaat kan worden hersteld naar een nieuw Apple ID-account als een nieuw apparaat.
</p>
<h4>3.7 Detectie van ongewenste tracking</h4>
<p style="text-align: left;">
Als een Zoek mijn-netwerkaccessoire dat van de eigenaar is gescheiden, na verloop van tijd met u meeverhuist, ontvangt u op twee manieren een melding: (1) Als u een iPhone of iPad hebt, stuurt Zoek mijn een melding naar uw Apple-apparaat. Deze functie is beschikbaar op iOS of iPadOS 14.5 of hoger. 2) Als u geen iOS-apparaat of smartphone hebt, geeft een Zoek mijn-netwerkaccessoire dat gedurende een bepaalde periode niet bij de eigenaar is, een geluidssignaal wanneer het wordt verplaatst.</p>
<p style="text-align: left;"> 
Deze functies zijn speciaal ontwikkeld om te voorkomen dat mensen u zonder uw medeweten proberen te volgen.
</p>
<h3>4. Specificaties</h3>
<ul>  
  <li>Batterij: CR2032 batterij</li>
  <li>Werkspanning: 2,8V-3,3V</li>
  <li>Capaciteit: 220 mAh</li>
  <li>bereik: 10-30m</li>
  <li>Zoemer: Max 100 DB</li>
  <li>Productafmeting: φ32X7,9mm</li>

  </ul>



  <h3>5. Knopfunctie</h3>
  <ol>
    <li style="text-align: left;">
      <strong>Inschakelen (Zoek mijn functie is ingeschakeld).</strong>
      <p>
      Houd de aan/uit knop 3 seconden ingedrukt om het apparaat in te schakelen. U hoort een beltoon om aan te geven dat het apparaat is
      ingeschakeld.
      </p>
      <p> Als het product niet aan je Apple ID is gekoppeld, wordt het binnen 10 minuten automatisch gesloten. Je moet de zoekfunctie opnieuw activeren om de koppeling voort te zetten.</p>
      </li>
    <li style="text-align: left;"> <strong>Uitschakelen</strong> 
      <p>
        Houd de aan/uit knop drie seconden ingedrukt en laat hem vervolgens los. U hoort twee pieptonen die aangeven dat het apparaat is uitgeschakeld.</p>
    </li>
     <li style="text-align: left;"> <strong>Query voor meer informatie inschakelen.</strong> 
      <p>
Druk twee keer snel achter elkaar op de functietoets. U hoort dan een bevestigingsgeluid. Deze handeling wordt weergegeven in de app
'Zoek mijn' om degene die het apparaat in handen krijgt te helpen bij het verkrijgen van de apparaatgegevens, zoals de contactgegevens van de eigenaar (als het item in de app is ingesteld op de verloren-modus) en het serienummer van het apparaat.
</p>

</li>

 <li style="text-align: left;"> <strong>Fabrieksinstellingen herstellen</strong>
  <p>
Druk twee keer op de functieknop, u hoort één pieptoon. Druk vervolgens vier keer snel achter elkaar op de functieknop en houd deze een vijfde keer ingedrukt totdat u een beltoon hoort. Het apparaat is nu gereset.
</p>
  
<p style="text-align: left;">
Er is een resetbewerking nodig om het apparaat in de koppelingsstatus te brengen</p>

</li>
</ol>

 <h3>6. Vervanging van batterij en koord</h3>
 <ol> 
    <li>Gebruik het gereedschap voor het openen van de schelp om de schelpopening te plaatsen.</li>
    <li>Draai het gereedschap voor het openen van de schelp 90 graden om de schelp te openen.</li>
    <li>Gebruik uw vingernagels om de behuizing voorzichtig te openen via de kleine opening aan de zijkant van uw Item Locator.</li>
    <li>Vervang de batterij door een nieuwe CR2032-batterij van 3 V. (Pluspool met de tekst naar boven).</li>

 </ol>

      <img src="../assets/open_tag_nl.png" alt="Wireless Tag Logo" class="image_1" />



  <h3>  FAQ  </h3>
  <h4>1. Waarom wordt de locatie van mijn apparaat niet bijgewerkt?</h4>
    <li style="text-align: left;">Er zijn twee principes voor rapportage over productpositionering. Als er veel Apple-apparaten in de buurt zijn, meldt elke nieuwe gebruiker in de buurt van dit apparaat zijn of haar locatie, meestal binnen 2-5 minuten. Als het apparaat niet is verplaatst, detecteren de ingebouwde sensoren dit en schakelt het apparaat over naar de slaapstand. De gerapporteerde locatie kan variëren van 30 minuten tot enkele uren. Maak je geen zorgen, de locatie die je ziet,
kan van 30 minuten of enkele uren geleden zijn, maar het is zeer waarschijnlijk dat het item niet is verplaatst en dat de locatie die je ziet de laatst bekende locatie is.</li>

    <h4>2. Wanneer u een apparaat koppelt met de Zoek mijn-app, maakt de telefoon verbinding
met de Apple-server. Het koppelen kan mislukken vanwege netwerkproblemen. Het volgende wordt aanbevolen: </h4>
<ol>
  <li style="text-align: left;">Wijzig het netwerk van de telefoon, bijvoorbeeld door te schakelen tussen wifi en mobiel.
De eerste koppeling kan lang duren, dus wacht even.
</li>
  <li style="text-align: left;">Reset uw apparaat.</li>
<li style="text-align: left;"> Herstel het apparaat met de Zoek mijn-app.
</li>
</ol>
<h3>Privacy en beveiliging</h3>
<p style="text-align: left; color:#333 "  >Je Locator zendt een beveiligd Bluetooth-signaal uit dat kan worden gedetecteerd door apparaten in de buurt van het Zoek mijn-netwerk. Deze apparaten sturen de locatie van je Locator naar iCloud, waarna je de Zoek mijn-app kunt openen en deze op een kaart kunt bekijken. Het hele proces is anoniem en versleuteld om je privacy te beschermen.</p>

<h3>WAARSCHUWING</h3>
<ol>
  <li>Verwijder en recycleer gebruikte batterijen onmiddellijk of gooi ze weg volgens de plaatselijke voorschriften. Houd ze buiten bereik van kinderen. Gooi batterijen NIET weg bij het huisvuil en verbrand ze niet.</li>
  <li>Zelfs gebruikte batterijen kunnen ernstig letsel of de dood veroorzaken.</li>
  <li>Neem contact op met een plaatselijk antigifcentrum voor informatie over de behandeling.</li>
  <li>Niet-oplaadbare batterijen mogen niet worden opgeladen.</li>
  <li>Niet geforceerd ontladen, opladen, demonteren, verhitten boven 50 °C/122 °F of verbranden. Dit kan leiden tot letsel door ontluchting, lekkage of explosie met chemische brandwonden tot gevolg.</li>
  <li>Het compatibele batterijtype is CR2032.</li>
  <li>De nominale batterijspanning: DC 3V</li>
  <li>Zorg ervoor dat de batterijen correct zijn geplaatst, met de juiste polariteit (+ en -).</li>
  <li>Gebruik geen oude en nieuwe batterijen, verschillende merken of typen batterijen door elkaar, zoals alkaline-, koolstof-zink- of oplaadbare batterijen.</li>
  <li> Verwijder de batterijen uit apparaten die gedurende een langere periode niet zijn gebruikt en recycle ze onmiddellijk, of gooi ze weg volgens de plaatselijke voorschriften.</li>
  <li> Sluit het batterijvak altijd goed af. Als het batterijvak niet goed sluit, stop dan met het gebruik van het product, verwijder de batterijen en houd ze buiten bereik van kinderen.</li>

</ol>
<h5>
 <p>Batterijtype: CR2032. Batterijspanning: 3V.</p>
<p>Bewaar in de originele verpakking totdat u deze gaat gebruiken;</p>
<p>Verwijder gebruikte batterijen onmiddellijk en houd ze buiten bereik van kinderen. GOOI BATTERIJEN NIET WEG MET HUISVUIL.</p>
</h5>

<img src="../assets/image_battery.png" class="image_1">

</div>

</template>

<script>
export default {
  name: 'IosNetherland',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>